import { createContext, useContext } from 'react';
export const ProductDataContext = /*#__PURE__*/createContext(undefined);
export const useProductData = () => {
  return useContext(ProductDataContext);
};